import { Inject, Injectable } from '@angular/core';
import { map, tap } from 'rxjs/operators';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import * as fromActions from './auth.actions';
import { LOCAL_STORAGE } from '@rci/storage/local-storage.service';
import { GUID_KEY } from '@rci/self-serve-fido/app.constant';
import { SESSION_STORAGE } from '@rci/storage/session-storage.service';

const STORAGE_KEYS = [GUID_KEY];

@Injectable()
export class AppStateEffects {
  loadAuthState$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromActions.loadAuthState),
      map(_ => {
        const guid = (this.sessionStorage.getItem(GUID_KEY) || this.localStorage.getItem(GUID_KEY) || '').replace(
          /"/g,
          '',
        );
        return fromActions.updateAuthState({ guid });
      }),
    ),
  );

  resetAuthState$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromActions.resetAuthState),
        tap(_ => {
          STORAGE_KEYS.forEach(key => {
            this.localStorage.removeItem(key);
            this.sessionStorage.removeItem(key);
          });
        }),
      ),
    { dispatch: false },
  );

  constructor(
    @Inject(LOCAL_STORAGE) private readonly localStorage: Storage,
    @Inject(SESSION_STORAGE) private readonly sessionStorage: Storage,
    private readonly actions$: Actions,
  ) {}
}
